import api from '../api/client';

export const ordemEntradaService = {
  // Listar ordem atual
  async listarOrdem(leilaoId) {
    const response = await api.get(`/organizadores/ordem-entrada/${leilaoId}`);
    return response.data;
  },

  // Listar lotes disponíveis
  async listarLotesDisponiveis(leilaoId) {
    const response = await api.get(`/organizadores/ordem-entrada/${leilaoId}/lotes-disponiveis`);
    return response.data;
  },

  // Adicionar lote à ordem
  async adicionarLote(leilaoId, loteId, posicao = null, justificativa = null) {
    const params = new URLSearchParams({ lote_id: loteId });
    if (posicao) params.append('posicao', posicao);
    if (justificativa) params.append('justificativa', justificativa);
    
    const response = await api.post(`/organizadores/ordem-entrada/${leilaoId}/adicionar?${params}`);
    return response.data;
  },

  // Remover lote da ordem
  async removerLote(leilaoId, loteId) {
    const response = await api.delete(`/organizadores/ordem-entrada/${leilaoId}/remover/${loteId}`);
    return response.data;
  },

  // Limpar toda a ordem (remover todos os lotes)
  async limparOrdem(leilaoId) {
    const response = await api.delete(`/organizadores/ordem-entrada/${leilaoId}/limpar`);
    return response.data;
  },

  // Reordenar lotes
  async reordenarLotes(leilaoId, ordens, loteMovidoId = null, justificativa = null) {
    const response = await api.put(`/organizadores/ordem-entrada/${leilaoId}/reordenar`, {
      ordens,
      lote_movido_id: loteMovidoId,
      justificativa
    });
    return response.data;
  },

  // Gerar ordem sequencial
  async gerarOrdemSequencial(leilaoId, lotesIds) {
    const response = await api.post(`/organizadores/ordem-entrada/${leilaoId}/sequencial`, {
      lotes_ids: lotesIds
    });
    return response.data;
  },

  // Gerar ordem manual (baseada no campo "ordem" de cada lote)
  async gerarOrdemManual(leilaoId) {
    const response = await api.post(`/organizadores/ordem-entrada/${leilaoId}/ordem-manual`);
    return response.data;
  },

  // Obter configuração de modo da ordem
  async obterConfiguracao(leilaoId) {
    const response = await api.get(`/organizadores/ordem-entrada/${leilaoId}/configuracao`);
    return response.data;
  },

  // Resetar modo para "auto"
  async resetarModo(leilaoId) {
    const response = await api.post(`/organizadores/ordem-entrada/${leilaoId}/resetar-modo`);
    return response.data;
  },

  // Todos os lotes do leilão (na ordem + disponíveis), normalizado para o preview do filtro
  async listarTodosLotes(leilaoId) {
    const [ordem, disponiveis] = await Promise.all([
      this.listarOrdem(leilaoId),
      this.listarLotesDisponiveis(leilaoId),
    ]);
    const naOrdem = ordem.map(item => ({
      id: item.lote_id,
      numero: item.lote_numero,
      descricao: item.lote_descricao,
      qtd: item.lote_qtd,
      fazenda_nome: item.fazenda_nome,
    }));
    return [...naOrdem, ...disponiveis];
  },

  // ── Filtro por Números (por organizador) ──────────────────────────────────

  async listarFiltroNumeros(organizadorId, leilaoId = null) {
    const params = leilaoId ? `?leilao_id=${leilaoId}` : '';
    const response = await api.get(`/organizadores/ordem-entrada/${organizadorId}/filtro-numeros${params}`);
    return response.data;
  },

  async salvarFiltroNumeros(organizadorId, regras) {
    const response = await api.post(`/organizadores/ordem-entrada/${organizadorId}/filtro-numeros/salvar`, { regras });
    return response.data;
  },

  async aplicarFiltroNumeros(organizadorId, leilaoId, regras = null) {
    const body = regras ? { regras } : {};
    const response = await api.post(`/organizadores/ordem-entrada/${organizadorId}/filtro-numeros/aplicar/${leilaoId}`, body);
    return response.data;
  },

  async limparFiltroNumeros(organizadorId) {
    const response = await api.delete(`/organizadores/ordem-entrada/${organizadorId}/filtro-numeros`);
    return response.data;
  }
};
